import { NavLink, Outlet, useParams, useLocation } from 'react-router-dom';
import { AdminPageShell } from './shared';

// Consolidated per-layout admin page. One shell + a tab strip; each tab is a
// nested route (renders | bom | files) so tabs are deep-linkable and refresh-safe.
const TABS = [
  { to: 'renders', label: 'Renders' },
  { to: 'bom', label: 'BOM' },
  { to: 'files', label: 'Source files' },
];

export function LayoutAdminPage() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  // The Layouts table passes the code via Link state so the title reads nicely
  // without an extra fetch; falls back to the id on a direct load.
  const code = (location.state as { code?: string } | null)?.code;
  const title = code ? `Layout ${code}` : `Layout #${id}`;

  const tabStrip = (
    <nav className="flex gap-1 border-b border-vari-soft-gray -mb-px">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) =>
            `px-4 py-2 text-sm border-b-2 transition-colors ${
              isActive
                ? 'border-vari-navy text-vari-navy font-medium'
                : 'border-transparent text-vari-gray hover:text-vari-navy'
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );

  return (
    <AdminPageShell title={title} backTo={{ href: '/admin/layouts', label: 'Layouts' }} stickyTop={tabStrip}>
      <div className="pt-5">
        <Outlet />
      </div>
    </AdminPageShell>
  );
}
